import React, { Component } from 'react';
import { salt } from '../../@helpers';
import Button from './Button';
import './style.scss';
class ButtonGroup extends Component {
  constructor() {
    super()
    this.state = {}
  }

  render() {
    let { data } = this.props
    if (data.lxl_button_group) {
      data = data.lxl_button_group
    }

    let classes = ['button_group']
    classes = classes.join(' ')
    return (
      <section
        className={classes}
      >
        {data && Array.from(data).map(button => {
          const destination_path = `lxl_button_destination_${button.lxl_button_variant}`

          return (
            <Button
              id={salt()}
              key={salt()}
              variant={button.lxl_button_variant}
              destination={button.lxl_button_variant === 'chatbot' ? button.lxl_button_variant : button[destination_path]}
              copy={button.lxl_button_copy}
              label={button.lxl_button_label}
            />
          )
        })}
      </section>
    )
  }
}

export default ButtonGroup